import React, { Component } from 'react'
import ReactModal from 'react-modal'

const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    display:         'flex',
    justifyContent:  'center',
    alignItems:      'center',
    zIndex:          10
  },
  content: {
    position:        'initial',
    backgroundColor: 'rgba(21, 24, 35, .8)',
    border:          'none',
    borderRadius:    'none',
    boxShadow:       '0 0 45px #000',
    padding:         'none',
    overflow:        'visible'
  }
}

export default class Modal extends Component {

  render() {
    return (
      <ReactModal
        contentLabel="Modal"
        style={modalStyles}
        {...this.props}>
        <div className="modal">
          {this.props.onRequestClose && (
            <div className="modal-close" onClick={this.props.onRequestClose}>
              Close
            </div>
          )}
          {this.props.children}
        </div>
      </ReactModal>
    )
  }
}



// WEBPACK FOOTER //
// client/components/Modal.js